import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
    { title: 'Admin', isLink: false },
    { title: 'Technology', href: '/admin/technology' },
    {
        title: 'Technology',
        prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
    },
];

const Title: PageTitle = {
    title: 'Technology',
    prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
};

export { Breadcrumbs, Title };